import Seo from "../components/Seo";
import LeadForm from "../components/LeadForm";
import { ShieldCheck, Clock, MessageSquare } from "lucide-react";

export default function RequestPilot() {
  return (
    <>
      <Seo
        path="/request-a-pilot"
        title="Request a Pilot"
        description="Discuss your shipment with GoAndTrack — a short form, a human reply, and an honest steer on which smart-label architecture fits."
      />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-2">
          <div>
            <h1 className="text-4xl font-semibold tracking-tight text-brand-navy sm:text-5xl">Discuss your shipment</h1>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-brand-slate md:text-lg">
              Three short steps. A human from GoAndTrack replies — usually within one business day — with an
              honest steer on fit, including when the answer is "don't buy either yet".
            </p>
            <ul className="mt-10 space-y-6">
              {[
                { icon: Clock, t: "One business day", b: "Typical response time for enquiries submitted on working days." },
                { icon: MessageSquare, t: "A scoping call, not a sales call", b: "We map your lanes and constraints before any hardware is discussed." },
                { icon: ShieldCheck, t: "Your data, handled properly", b: "Details stored with your consent, used only to respond to this enquiry. See the privacy policy." },
              ].map(({ icon: Icon, t, b }) => (
                <li key={t} className="flex gap-4">
                  <Icon className="mt-0.5 h-6 w-6 flex-shrink-0 text-primary" strokeWidth={1.75} aria-hidden="true" />
                  <div>
                    <p className="text-sm font-semibold text-brand-navy">{t}</p>
                    <p className="mt-1 text-sm leading-relaxed text-brand-slate">{b}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div><LeadForm /></div>
        </div>
      </section>
    </>
  );
}
